// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".bread-container[data-v-d3c75896] {\n  margin-left: 0.052083rem;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 90>"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B","file":"bread.vue","sourcesContent":[".bread-container {\n  margin-left: 0.052083rem;\n}"]}]);
// Exports
module.exports = exports;
